import styled from "styled-components";

const StyledLink = styled.a`
    text-decoration:underline;
    -webkit-text-fill-color: #000
    margin-right: 5px;
`;

export default StyledLink